import loadable from '@loadable/component';

export const CmsStickyHeaderLinksBlockLoadable = loadable(
  () => import('./CmsStickyHeaderLinksBlock'),
  { resolveComponent: (module) => module.CmsStickyHeaderLinksBlock },
);
